import { Button, Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block, Save } from "@material-ui/icons";
import Config, { PAYMENT_VOUCHER_IMAGE_UPLOAD_LIMIT } from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import PopupForm from "app/common/Component/Popup/PopupForm";
import TableComponent from "app/common/Component/Table/TableComponent";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import {
  LAVoucherItemRevenueType,
  PathModule,
  VOUCHER_INVOICE_TYPE_VALUE,
} from "app/common/LocalConst";
import {
  config_resizeImg,
  formatMoney,
  getDateTime,
  getPositionCodes,
  isAdmin,
  isRoleEditRevenueType,
  validateEqualsSourceDiffirentTelesale,
  validateMaxTotalAmountTelesale,
  validateMaxTotalDiffTelesale,
  validateSelectDiffirentTelesale,
  validateSelectTelesale,
  validateVoucherPaymentMethods,
  transformDate,
} from "app/common/LocalFunction";
import { pagingDepartment } from "app/services/DepartmentService";
import { uploadFile } from "app/services/FileDescriptionExtService";
import { pagingStaff } from "app/services/StaffService";
import { useStore } from "app/stores";
import imageCompression from "browser-image-compression";
import { useFormikContext } from "formik";
import lgFullscreen from "lightgallery/plugins/fullscreen";
import lgRotate from "lightgallery/plugins/rotate";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import LightGallery from "lightgallery/react";
import { observer } from "mobx-react";
import { memo, useEffect } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import * as Yup from "yup";
import StaffRevenuesFee from "../Component/StaffRevenuesFee";
import TotalOfVoucherByUpdate from "../Component/TotalOfVoucherByUpdate";

const VoucherPopupDetail = ({
  open,
  handleClose,
  detailData,
  editable = false,
  setOpenStaffRevenueUpdate,
  handleUpdateVoucher,
  patientId,
  handleAfterSubmit,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const validationSchema = Yup.object().shape({
    items: Yup.array().of(
      Yup.object().shape({
        staffRevenues: Yup.array()
          .min(1, "Cần thêm ít nhất 1 phân bổ!")
          .of(
            Yup.object()
              .shape({
                position: Yup.object()
                  .nullable()
                  .required("Bắt buộc nhập chức danh"),
                staff: Yup.object().nullable(),
                source: Yup.object()
                  .nullable()
                  .required("Bắt buộc phải chọn nguồn phân bổ"),

                actualAmount: Yup.number()
                  .min(0, "Doanh thu phải lớn hơn 0!")
                  .nullable(),
              })
              .test(
                "at-least-one-selected",
                "Phải chọn Nhân viên!",
                function (value) {
                  if (!value) return false;
                  const { staff } = value;
                  return !!staff;
                },
              ),
          )
          .test(
            "at-least-one-diffirent-sale",
            "Cần chọn phân bổ cho người tư vấn !",
            validateSelectDiffirentTelesale,
          )
          .test(
            "at-least-one-sale",
            "Cần chọn phân bổ cho telesale!",
            validateSelectTelesale,
          )
          .test(
            "max-total-amount-telesale",
            "Tổng phân bổ telesale phải bằng 100%",
            validateMaxTotalAmountTelesale,
          )
          .test(
            "max-total-amount-consultant",
            "Tổng phân bổ tư vấn viên và kĩ thuật viên phải bằng 100%",
            validateMaxTotalDiffTelesale,
          )
          .test(
            "equals-source-revenue-sale-diffirent",
            "Tổng phân bổ telesale phải bằng các chức danh khác trong cùng nguồn!",
            validateEqualsSourceDiffirentTelesale,
          )
          .nullable(),
      }),
    ),
    voucherPaymentMethods: Yup.array().of(
      Yup.object()
        .shape()
        .test(
          "Validate voucher bank",
          "Bắt buộc chọn stk",
          validateVoucherPaymentMethods,
        ),
    ),
    voucherDate: Yup.date()
      .transform(function (_, originalValue) {
        if (!originalValue) return null;
        if (Array.isArray(originalValue) && originalValue.length >= 3) {
          return moment([
            originalValue[0],
            originalValue[1] - 1,
            originalValue[2],
            originalValue[3] || 0,
            originalValue[4] || 0,
            originalValue[5] || 0,
          ]).toDate();
        }
        return moment(originalValue).toDate();
      })
      .typeError("Ngày chi chưa đúng định dạng!")
      .nullable()
      .test(
        "is-after-registration-date",
        "Ngày lập không được nhỏ hơn ngày đăng ký gần nhất!",
        function (value) {
          if (!value) return true;
          const { items } = this.parent;
          let latestDate = null;

          if (items && items.length > 0) {
            items.forEach((item) => {
              if (!item.invoiceItem) return;
              let dStr = item.invoiceItem.invoiceDate;
              if (dStr) {
                let d;
                if (Array.isArray(dStr) && dStr.length >= 3) {
                  d = moment([
                    dStr[0],
                    dStr[1] - 1,
                    dStr[2],
                    dStr[3] || 0,
                    dStr[4] || 0,
                    dStr[5] || 0,
                  ]);
                } else {
                  d = moment(dStr);
                }

                if (d.isValid()) {
                  if (!latestDate || d.isAfter(latestDate)) {
                    latestDate = d;
                  }
                }
              }
            });
          }

          if (latestDate) {
            let voucherDate = moment(value);
            return voucherDate.isSameOrAfter(latestDate);
          }
          return true;
        },
      ),
  });

  const {
    resetStorePopup,
    listStk,
    listPos,
    listHomecredit,
    listPos_tragop,
    listPaymentMethod,
  } = useStore().feeStore.serviceFeeTabStore;

  useEffect(() => {
    return () => resetStorePopup();
  }, []);

  return (
    <PopupForm
      open={open}
      size="xxl"
      handleClose={handleClose}
      title={"Danh sách phiếu chi tiết"}
      // hideFooter={true}
      formik={{
        initialValues: {
          ...detailData,
        },
        validationSchema: validationSchema,
        // onSubmit: handleUpdateVoucher,
        onSubmit: async (values, { setSubmitting }) => {
          let data = await handleUpdateVoucher(values, {
            setSubmitting,
          });
          if (handleAfterSubmit) {
            handleAfterSubmit(data);
          }
        },
        enableReinitialize: true,
      }}
      action={({ isSubmitting, values }) => {
        return (
          <div className="flex-center gap-1">
            {editable && (
              <CommonButton type="submit" disabled={isSubmitting}>
                {!isMobile && <Save className="mr-2 " />}
                {"Cập nhật"}
              </CommonButton>
            )}

            <CommonButton
              className="btn-gray"
              onClick={handleClose}
              //disabled={isSubmitting}
            >
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ values, setFieldValue }) => (
        <>
          <ValueForm
            editable={editable}
            setOpenStaffRevenueUpdate={setOpenStaffRevenueUpdate}
            listStk={listStk}
            listPos={listPos}
            listHomecredit={listHomecredit}
            listPos_tragop={listPos_tragop}
            listPaymentMethod={listPaymentMethod}
          />

          <DialogError
            values={values}
            patientId={patientId}
            setFieldValue={setFieldValue}
          />
        </>
      )}
    </PopupForm>
  );
};

const ValueForm = ({
  editable,
  listStk,
  listPos,
  listPos_tragop,
  listHomecredit,
  listPaymentMethod,
}) => {
  const { values, setFieldValue } = useFormikContext();
  let POSITION_CODES = getPositionCodes();
  let isAdvance =
    VOUCHER_INVOICE_TYPE_VALUE.Advance === values?.voucherInvoiceType;
  const { fetchImage, getImageUrl } = useStore().feeStore.serviceFeeTabStore;
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const hasEditDepartment = isAdmin();

  const handleImageChange = async (e, itemId = null) => {
    try {
      const files = Array.from(e.target?.files || []);
      if (!files.length || !values || typeof setFieldValue !== "function")
        return;
      // console.log("File gốc trước khi nén");
      // files.forEach((f) => console.log(f.name, f.type, (f.size / 1024).toFixed(2), "KB"));
      let updatedList = [...(values.attachments || [])];

      if (
        !itemId &&
        updatedList.length + files.length > PAYMENT_VOUCHER_IMAGE_UPLOAD_LIMIT
      ) {
        toast.warning(
          `Chỉ được phép tải tối đa ${PAYMENT_VOUCHER_IMAGE_UPLOAD_LIMIT} ảnh!`,
        );
        return;
      }

      const compressedFiles = await Promise.all(
        files.map(async (file) => {
          const compressedBlob = await imageCompression(file, config_resizeImg);
          // console.log(`Đã nén ${file.name}: ${(compressedBlob.size / 1024).toFixed(2)} KB`);
          return new File([compressedBlob], file.name, { type: file.type });
        }),
      );

      for (const file of compressedFiles) {
        const res = await uploadFile(file);
        const newFileId = res?.data?.id;
        const newFileName = res?.data?.name;
        if (!newFileId) continue;

        if (itemId) {
          updatedList = updatedList.filter((x) => x.id !== itemId);
        }
        updatedList.push({ id: newFileId, name: newFileName });
        fetchImage(newFileId);
      }
      setFieldValue("attachments", updatedList);
      setFieldValue(
        "attachmentIds",
        updatedList.map((x) => x.id),
      );
    } catch (err) {
      console.error("Lỗi upload ảnh:", err);
    } finally {
      if (e.target) e.target.value = "";
    }
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} lg={9}>
        <Grid container spacing={1}>
          <Grid item xs={12} lg={3}>
            <GlobitsTextField label={"Mã phiếu"} name="code" disabled />
          </Grid>
          <Grid item xs={12} lg={3}>
            <GlobitsPagingAutocomplete
              label={"Cơ sở"}
              name="department"
              api={pagingDepartment}
              disabled={!hasEditDepartment || !editable}
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <GlobitsPagingAutocomplete
              label="Người lập"
              name="accountant"
              displayLabel="staffName"
              api={pagingStaff}
              disabled
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <GlobitsDateTimePicker
              label={"Thời gian tạo phiếu"}
              name="voucherDate"
              isDateTimePicker
            />
          </Grid>

          <Grid item xs={12} lg={3}>
            <GlobitsVNDCurrencyInput
              label={`${
                values?.voucherInvoiceType === VOUCHER_INVOICE_TYPE_VALUE.Refund
                  ? "Tổng chi"
                  : "Tổng thu"
              } `}
              name="totalAmount"
              disabled
            />
          </Grid>
          {!isAdvance && (
            <>
              <Grid item xs={12} lg={3}>
                <GlobitsVNDCurrencyInput
                  label={"Giảm giá tổng hóa đơn"}
                  name="allocateDiscount"
                  disabled
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <GlobitsVNDCurrencyInput
                  label={"Tiền thu sau giảm"}
                  name="moneyAfterDiscount"
                  disabled
                />
              </Grid>
            </>
          )}
          <Grid item xs={12} lg={3}>
            <GlobitsVNDCurrencyInput
              label={"Tổng phí"}
              name="totalInstallmentFee"
              disabled
            />
          </Grid>
          {editable && (
            <Grid item xs={12} lg={3}>
              <button
                type="button"
                style={{
                  padding: "6px 12px",
                  backgroundColor: "#4276a4",
                  color: "#fff",
                  border: "none",
                  borderRadius: 4,
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  marginTop: "15px",
                }}
                onClick={() =>
                  document.getElementById("upload-new-attachment")?.click()
                }
              >
                + Tải ảnh lên
              </button>
              <input
                id="upload-new-attachment"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                multiple
                onChange={(e) => handleImageChange(e)}
              />
            </Grid>
          )}
          <Grid item xs={12} lg={3}>
            <GlobitsTextField
              name="note"
              label="Nội dung"
              isTextArea
              rows={3}
              disabled={!editable}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} lg={3}>
          <div style={{ fontWeight: 600, marginTop: 8 }}>Ảnh phiếu chi</div>

          <div
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
              paddingTop: 8,
              width: "975px",
            }}
          >
            {(values?.attachments || []).map((item) => (
              <ImageItem
                key={item.id}
                item={item}
                editable={editable}
                handleImageChange={handleImageChange}
                getImageUrl={getImageUrl}
                fetchImage={fetchImage}
              />
            ))}
          </div>
        </Grid>
      </Grid>
      <Grid item xs={12} lg={3}>
        <TotalOfVoucherByUpdate
          nameSpace={"voucherPaymentMethods"}
          listStk={listStk}
          listPos={listPos}
          listHomecredit={listHomecredit}
          listPos_tragop={listPos_tragop}
          listPaymentMethod={listPaymentMethod}
          moneyAfterDiscount={values?.moneyAfterDiscount}
          editable={editable}
          patientId={patientId}
        />
      </Grid>

      <Grid item xs={12}>
        <TableComponent
          className=""
          showOrdinalNumbers
          titleNodata={"noData"}
          data={values?.items || []}
          columns={[
            {
              field: "content",
              title: "Tên dịch vụ",
              render: (row) => {
                let registrationDate = row?.invoiceItem?.invoiceDate;

                return (
                  <>
                    <div>
                      <span>{row?.content}</span>
                      {registrationDate && (
                        <div
                          style={{
                            fontSize: "12px",
                            color: "gray",
                            marginTop: "4px",
                          }}
                        >
                          <i>Ngày ĐK: {getDateTime(registrationDate)}</i>
                        </div>
                      )}
                    </div>
                    <div className="flex mt-2">
                      <div>
                        Thu:{" "}
                        <b style={{ color: "red" }}>
                          {formatMoney(row?.amount)}
                        </b>
                      </div>
                      <span className="mx-2 text-gray-400">|</span>
                      <div>
                        Cần thu:{" "}
                        <b style={{ color: "green" }}>
                          {formatMoney(row?.moneyAfterDiscount || 0)}
                        </b>
                      </div>
                      <span className="mx-2 text-gray-400">|</span>
                      <div>
                        Phí:{" "}
                        <b style={{ color: "light-blue" }}>
                          {formatMoney(row?.installmentFee || 0)}
                        </b>
                      </div>
                    </div>
                  </>
                );
              },
            },
            {
              field: "voucherItemRevenueType",
              title: "Doanh thu (mới cũ)",
              render: (row, index) => (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <GlobitsSelectInput
                    name={`items[${index}].voucherItemRevenueType`}
                    options={LAVoucherItemRevenueType.getListData()}
                    onChange={(e) => {
                      const selectedValue = e?.target?.value;
                      setFieldValue(
                        `items[${index}].voucherItemRevenueType`,
                        selectedValue,
                      );
                    }}
                    style={{
                      width: "100%",
                      minWidth: 175,
                    }}
                    disabled={(!isAdmin() && !isRoleEditRevenueType()) || row?.locked === true}
                  />
                </div>
              ),
            },
            {
              field: "content",
              title: "Phân bổ doanh thu (nhân viên)",

              render: (row, index) => (
                <div className="staff-list">
                  <div style={{ width: "100%" }}>
                    <StaffRevenuesFee
                      editable={editable}
                      index={index}
                      row={row}
                      POSITION_CODES={POSITION_CODES}
                      hiddenAddStaff={row?.locked}
                    />
                  </div>
                </div>
              ),
            },
          ]}
        />
      </Grid>
    </Grid>
  );
};

const ImageItem = observer(
  ({ item, editable, handleImageChange, getImageUrl, fetchImage }) => {
    const imageUrl = getImageUrl(item?.id);
    const { values, setFieldValue } = useFormikContext();
    useEffect(() => {
      if (!imageUrl) fetchImage(item.id);
    }, [imageUrl, item.id]);

    if (!imageUrl) {
      return (
        <div
          key={item?.id}
          style={{
            display: "inline-block",
            width: 80,
            marginRight: 8,
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: 80,
              height: 80,
              border: "1px dashed #ccc",
              lineHeight: "80px",
              fontSize: 12,
              color: "#888",
            }}
          >
            Đang tải...
          </div>
        </div>
      );
    }

    return (
      <div
        key={item?.id}
        style={{
          display: "inline-block",
          width: 80,
          marginRight: 8,
          textAlign: "center",
          position: "relative",
        }}
      >
        {editable && (
          <button
            onClick={() => {
              const updatedList = (values.attachments || []).filter(
                (x) => x.id !== item.id,
              );
              setFieldValue("attachments", updatedList);
              setFieldValue(
                "attachmentIds",
                updatedList.map((x) => x.id),
              );
            }}
            style={{
              position: "absolute",
              top: 2,
              right: 1,
              border: "none",
              background: "transparent",
              fontSize: "16px",
              cursor: "pointer",
              color: "black",
              zIndex: 1,
            }}
            title="Xóa ảnh"
          >
            ×
          </button>
        )}

        <LightGallery
          speed={500}
          plugins={[lgThumbnail, lgZoom, lgFullscreen, lgRotate]}
          mode="lg-fade"
          elementClassNames="light-gallery-single"
        >
          <a
            href={imageUrl}
            data-src={imageUrl}
            data-lg-size="1200-800"
            style={{
              display: "block",
              width: 80,
              height: 80,
              border: "1px solid #ccc",
              borderRadius: 4,
              overflow: "hidden",
              marginBottom: 4,
            }}
          >
            <img
              src={imageUrl}
              alt="Ảnh"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </a>
        </LightGallery>

        {editable && (
          <>
            <Button
              size="small"
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                document.getElementById(`upload-${item?.id}`)?.click();
              }}
              style={{ width: "80px" }}
            >
              Sửa ảnh
            </Button>

            <input
              type="file"
              accept="image/*"
              id={`upload-${item?.id}`}
              style={{ display: "none" }}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => handleImageChange(e, item.id)}
            />
          </>
        )}
      </div>
    );
  },
);

const DialogError = observer(({ patientId, values, setFieldValue }) => {
  const { openConfirmMessage, handleCloseConfirmMessage } =
    useStore().feeStore.serviceFeeTabStore;
  return (
    <>
      {!!openConfirmMessage && (
        <ConfirmPopup
          open={!!openConfirmMessage}
          onClose={() => {
            handleCloseConfirmMessage(null);
            setFieldValue("voucherDate", values?.voucherDate);
          }}
          text={openConfirmMessage}
          onConfirm={() => {
            const url =
              Config.ROOT_PATH +
              PathModule.PATIENT_MANAGEMENT +
              `/patient-general?patientId=${patientId}`;

            window.open(url, "_blank");
          }}
          textConfirm={"Thông tin khách"}
          textClose={"Quay lại"}
          title="Thao tác thất bại"
          isNotAPromise
        />
      )}
    </>
  );
});

export default memo(observer(VoucherPopupDetail));
